import styled from '@emotion/styled';
import { Card, CardContent } from '@material-ui/core';
import { createElement, FC } from 'react';

import DummyAvatarAndName from '../compound/DummyAvatarAndName';
import AspectRatioFixed from '../primitive/AspectRatioFixed';
import DummyContent from '../primitive/DummyContent';
import DummyRectangle from '../primitive/DummyRectangle';
import { CardHeader } from './CreationsList/Item';

interface Props {
  className?: string;
}

const DummyCreationsListItem: FC<Props> = ({ className }) => {
  return (
    <Card className={className}>
      <CardHeader>
        <DummyName size="subtitle1" />
        <DummyCreativeFormat />
      </CardHeader>
      <DummyThumbnail aspectRatio={[4, 3]}>
        <DummyRectangle />
      </DummyThumbnail>
      <CardContent>
        <DummyAssignee />
        <DummyCreatedAt size="caption" />
      </CardContent>
    </Card>
  );
};

const DummyThumbnail = styled(AspectRatioFixed)();

const DummyName = styled(DummyContent)();

const DummyCreativeFormat = styled(DummyContent)();

const DummyCreatedAt = styled(DummyContent)();

const DummyAssignee = styled(DummyAvatarAndName)();

export default DummyCreationsListItem;
